import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  group: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    flexFlow: 'column'
  },

  title: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '1.5rem',
    color: '#323436',

    '& > :nth-child(2)': {
      opacity: '0.35',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    }
  },

  root: {
    '& .label': {
      textTransform: 'none',
      width: '135px'
    },

    '& .cf-input-root': {
      marginTop: 16
    }
  }
}))

export default useStyles
